<template>
    <div v-if="!hintToCreateTransfer"
        class="fixed bottom-0 left-0 m-0 z-2 
            right-0 xl:right-auto lg:right-auto md:right-auto">
        <div class="block relative w-auto surface-0 border-round-lg shadow-8 px-3 py-4 mx-3 mb-3 cursor-pointer 
            xl:max-w-20rem lg:max-w-20rem md:max-w-20rem sm:max-w-20rem">
            <span class="text-xl block mb-3 text-700">{{ buttons[lang_].how2create }}</span>
            <Button :label="buttons[lang_].watchVideo" class="flex w-full align-items-center border-round-lg" 
                @click="show_video('howToCreateTransfer')" icon="pi pi-play" iconPos="right"/>
            <div @click="close_hint('howToCreateTransfer')"
                class="w-2rem h-2rem surface-0 border-round-lg absolute top-0 right-0 cursor-pointer p-2">
                <i class="pi pi-times absolute text-500" style="font-size: 1rem"></i>
            </div>
        </div>
    </div>
    <Dialog v-model:visible="showToCreateTransfer" :header="buttons[lang_].header" modal blockScroll
        :style="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screen_size=='xs') ? 'h-full' : ''"
        class="w-full" style="max-width: 800px">
        <div v-if="isTgApp">
            <iframe width="100%" height="500" src="https://www.youtube.com/embed/6B7hKQL9d5c" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div v-else>
            <iframe v-if="(screen_size=='sm' || screen_size=='xs')" width="100%" height="500" src="https://www.youtube.com/embed/sMwYNxul8yQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <iframe v-else width="100%" height="315" src="https://www.youtube.com/embed/sMwYNxul8yQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </Dialog>
</template>

<script>
import { useCookies } from "vue3-cookies"

export default {
    name: 'hintVideo',
    data() {
        return {
            showToCreateTransfer: false,
            buttons:  {
                ru:{
                    how2create: "Смотрите видео инструкцию – как сделать первый перевод 👇",
                    watchVideo: "Смотреть видео",
                    header: 'Как сделать перевод'
                },
                en:{
                    how2create: "Watch the video instruction on how to make a transfer 👇",
                    watchVideo: "Watch video",
                    header: 'How to make a transfer'
                }              
            },
            cookies: useCookies(),
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screen_size() { return this.$store.getters.StateScreenSize },
        hintToCreateTransfer(){ return this.$store.getters.StateHintToCreateTransfer },
        isTgApp() { return (this.initData) ? true : false },
    },
    methods: {
        async show_video(name) {
            if(name=='howToCreateTransfer'){
                this.showToCreateTransfer = true
            }
        },
        async close_hint(name) {
            if(name=='howToCreateTransfer') {
                this.hintToCreateTransfer = false
                try{
                    await this.$store.dispatch('sawHowToCreateTr', true).then(() => {})
                } catch {}
                this.cookies.cookies.set("saw_video_howToCreateTransfer", true)
                localStorage.setItem('saw_video_howToCreateTransfer', true)
            }
        },
    }
}
</script>